import { render, staticRenderFns } from "./InputDashboard.vue?vue&type=template&id=3f6cce89&lang=pug&"
import script from "./InputDashboard.vue?vue&type=script&lang=js&"
export * from "./InputDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InputDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports